import Carousel from './Carousel';
import YearTab from "./YearTab";

export default function ProjectsHolder({ projects }) {

    if (!projects) return;
    
    projects = Object.values(Object.groupBy(projects, ({Year})=>Year)).sort((a,b)=>(b[0].Year-a[0].Year));
    
    return (
        <div id="carousels">
            {projects.map(projectsbyyear => (
                <div key={"DIV-"+projectsbyyear[0].Year} id={projectsbyyear[0].Year} className="yearholder">
                    {projectsbyyear.map((project,idx) => project.Sources?(
                        <Carousel
                            key={project.ProjectID}
                            id={project.ProjectID}
                            sources={project.Sources.split(';')}
                            types={project.Types.split(';')}
                            desc={project.ProjectDesc}
                            idx={idx}
                        >
                            {idx===0&&<YearTab key={"TAB-"+projectsbyyear[0].Year} year={projectsbyyear[0].Year} />}
                        </Carousel>
                    ):null)}
                </div>
            ))}
        </div>
    )
}